import * as React from 'react'
import { Menu, Segment } from 'semantic-ui-react'

interface HeaderProps {
  style?: React.CSSProperties
  items: { [key: string]: string }[]
  onClick: (name: string) => void
  active: string
}

export default class HeaderMol extends React.Component<HeaderProps, {}> {
  render() {
    const { onClick, style, items, active } = this.props
    return (
      <div style={{ ...style }}>
        <Menu inverted style={{ overflow: 'auto' }}>
          {items.map(item => {
            const name = Object.keys(item)[0]
            return (
              <Menu.Item
                key={name}
                name={name}
                active={item[name] === active}
                color={item[name] === active ? 'green' : 'green'}
                onClick={() => {
                  onClick(item[name])
                }}
              />
            )
          })}
        </Menu>
      </div>
    )
  }
}
